import { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import Spinner from '../markup/page-animation/spinner';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfViewer = () => {
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.0);
  const [pages, setPages] = useState([]);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPages(Array.from(new Array(numPages), (el, index) => index + 1));
  }

  const adjustScale = () => {
    const width = window.innerWidth;
    if (width < 480) {
      setScale(0.3);
    } else if (width < 768) {
      setScale(0.4);
    } else if (width < 1024) {
      setScale(0.5);
    } else {
      setScale(0.65);
    }
  };

  useEffect(() => {
    adjustScale();
    window.addEventListener('resize', adjustScale);
    return () => window.removeEventListener('resize', adjustScale);
  }, []);

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = '/Norsal-Tanitim.pdf';
    link.download = 'Norsal-Tanitim.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="pdf-viewer">
      <div className="pdf-header">
        <h2>Broşür</h2>
        <button className="download-button" onClick={handleDownload}>
          <span>İndir</span>
          <i className="fa fa-download"></i>
        </button>
      </div>

      <Document
        file="/Norsal-Tanitim.pdf"
        onLoadSuccess={onDocumentLoadSuccess}
        loading={
          <div className="loading">
            <Spinner />
          </div>
        }
      >
        <div className="pdf-pages">
          {pages.map(pageNumber => (
            <Page
              key={pageNumber}
              pageNumber={pageNumber}
              scale={scale}
              loading={
                <div className="loading">
                  <Spinner />
                </div>
              }
            />
          ))}
        </div>
      </Document>

      <div className="pdf-footer">
        <img src={require("../images/Norsal-Transparent-bg.webp")} alt="Norsal Logo" className="footer-logo" />
        <p className="footer-text">
          Daha fazla bilgi için 
          <a href="https://www.norsal.com.tr" rel="noopener noreferrer">
            web sitemizi
          </a> 
          ziyaret edebilirsiniz
        </p>
      </div>
    </div>
  );
};

export default PdfViewer;